import {
  ActionIcon,
  Box,
  Center,
  Flex,
  Paper,
  Popover,
  ScrollArea,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import IconInfoCircle from '@tabler/icons-react/dist/esm/icons/IconInfoCircle.mjs';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { CI } from '../model/ci';
import { useCITypeMapStorage } from '../model/ci-type-map-storage';
import { CITypeIcon } from './ci-type';

interface CIsWithoutCoordinatesProps {
  cisWithoutCoordinates?: CI[];
}

export const CIsWithoutCoordinates = ({
  cisWithoutCoordinates,
}: CIsWithoutCoordinatesProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const parentRef = useRef(null);
  const rowVirtualizer = useVirtualizer({
    count: cisWithoutCoordinates?.length || 0,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 30,
  });

  const { data: ciTypeMap } = useCITypeMapStorage();
  return (
    <Paper
      className={'absolute z-[4] overflow-hidden flex flex-col'}
      p={'xs'}
      radius={'sm'}
      shadow={'lg'}
      left={theme.spacing.xs}
      bottom={theme.spacing.xs}
      withBorder
      // style={{
      //   maxHeight: height - (px(theme.spacing.xs) as number) * 2,
      // }}
    >
      <Center>
        <Popover withArrow keepMounted position={'right-end'}>
          <Popover.Target>
            <ActionIcon size={'sm'} variant={'light'}>
              <IconInfoCircle />
            </ActionIcon>
          </Popover.Target>
          <Popover.Dropdown key={cisWithoutCoordinates?.length}>
            <Stack w={250}>
              <Text>{`${t('widgets.charts.map.cisWithoutCoordinates', { ns: 'dashboard-tab' })}: ${cisWithoutCoordinates?.length}`}</Text>
              <ScrollArea.Autosize mah={200} viewportRef={parentRef}>
                <Stack
                  style={{
                    height: `${rowVirtualizer.getTotalSize()}px`,
                    width: '100%',
                    position: 'relative',
                  }}
                  gap={'xs'}
                >
                  {rowVirtualizer.getVirtualItems().map((virtualItem) => {
                    const item = cisWithoutCoordinates[virtualItem.index];

                    return (
                      <Flex
                        gap={'xs'}
                        wrap={'nowrap'}
                        key={virtualItem.index}
                        ref={rowVirtualizer.measureElement}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: `${virtualItem.size}px`,
                          transform: `translateY(${virtualItem.start}px)`,
                        }}
                      >
                        <Box>
                          <CITypeIcon
                            src={ciTypeMap.get(item.ci_type_name)?.icon}
                          />
                        </Box>
                        <Text truncate={'end'}>{item.ci_name}</Text>
                      </Flex>
                    );
                  })}
                </Stack>
              </ScrollArea.Autosize>
            </Stack>
          </Popover.Dropdown>
        </Popover>
      </Center>
    </Paper>
  );
};